import React, { useState } from "react";
import ImageModal from "./ImageModal";

const ProductImages = ({ mainImage, thumbnailImages, allImages, additionalCount, vehicleName = "Campervan" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  // Use allImages prop for modal if provided, otherwise combine displayed images
  const modalImages = allImages || [mainImage, ...thumbnailImages];

  const openModal = (imageIndex) => {
    setSelectedImageIndex(imageIndex);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="product-images">
        <img
          src={mainImage}
          alt={`${vehicleName} campervan exterior view - solar-powered rental in Portugal`}
          className="main-image clickable-image"
          onClick={() => openModal(0)}
        />
        <div className="thumbnail-images">
          {thumbnailImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${vehicleName} campervan view ${index + 2} - interior and features`}
              className="thumbnail-image clickable-image"
              onClick={() => openModal(index + 1)}
            />
          ))}
          {additionalCount > 0 && (
            <div
              className="thumbnail-image-container clickable-image"
              onClick={() => openModal(thumbnailImages.length)}
            >
              <img
                src={thumbnailImages[thumbnailImages.length - 1]}
                alt={`View more ${vehicleName} campervan photos`}
                className="thumbnail-image-background"
              />
              <div className="thumbnail-overlay" />
              <div className="thumbnail-image-count">+{additionalCount}</div>
            </div>
          )}
        </div>
      </div>

      <ImageModal
        images={modalImages}
        isOpen={isModalOpen}
        onClose={closeModal}
        initialIndex={selectedImageIndex}
      />
    </>
  );
};

export default ProductImages;
